import React from "react";

import { DropdownFilter } from "../../../../components/_dropdown-filter";

import { VARIABLE_VALUE_FALLBACK_STRING, type VariableState } from "./_common";

interface Props extends Pick<VariableState, "variable"> {
	children: React.ReactElement;
}

export const Wrapper = ({ children, variable }: Props): React.JSX.Element => (
	<DropdownFilter
		align={{
			targetOffset: [0, 4],
			overflow: { adjustX: false, adjustY: false },
		}}
		destroyPopupOnHide={false}
		fallbackSelectedLabel={VARIABLE_VALUE_FALLBACK_STRING}
		label={variable.label ?? variable.name}
		overlay={() => children}
		placement="bottomRight"
		selectedLabel={variable.displayValue}
	/>
);
